// CloudFront domain for screenshots
export const CLOUDFRONT_DOMAIN = 'https://d3lox7nr5xy0y9.cloudfront.net';

// Salesforce app installation URL
export const SALESFORCE_APP_INSTALL_URL = 'https://login.salesforce.com/packaging/installPackage.apexp?p0=04tgK0000005tzxQAA';

export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiamlyaWwiLCJhIjoiY21oY3lyNXRoMXF1bjJvb28zNmplcG5rZyJ9.7htQCNi-yUt2oPayXne44Q';

// Keystone (new contact processing system) version threshold
const KEYSTONE_VERSION_THRESHOLD = 35;

/**
 * Check if the data version is from keystone (new contact processing system).
 * Keystone versions are 35 and above.
 */
export function isKeystoneVersion(version: number | undefined | null): boolean {
  return typeof version === 'number' && version >= KEYSTONE_VERSION_THRESHOLD;
}